import React, { useEffect } from "react";
import "./CustomFormComponent.scss";
import Select from "react-select";

const OffsiteActivityStaticForm = ({
  formData,
  setFormData,
  formFields,
  disabled,
  setSubmitDisable,
  //   option,
}) => {
  const handleChange = (name, newValue) => {
    if (name === formFields[0].name && newValue === "Yes") {
      setFormData((prevData) =>
        prevData.map((field) => {
          if (field.name === "locationAudited") {
            return {
              ...field,
              value: "Yes",
            };
          }

          if (
            field.name === "offsiteActivity" ||
            field.name === "locationAudited" ||
            field.name === "siteName" ||
            field.name === "AuditingLocation"
          ) {
            return { ...field, value: "" };
          }
          return field; // Make sure to return the field if it doesn't match the condition
        })
      );
    }

    // Check if the name matches the first field "offSiteActivities"
    if (name === formFields[0].name && newValue === "No") {
      // If true, update the specified fields to "NA" and also set the new value to the 'name' field
      setFormData((prevData) =>
        prevData.map((field) => {
          if (
            field.name === "offsiteActivity" ||
            field.name === "locationAudited" ||
            field.name === "siteName" ||
            field.name === "AuditingLocation"
          ) {
            return { ...field, value: "NA" };
          }
          // Also update the 'name' field's value to match the newValue
          if (field.name === name) {
            return { ...field, value: newValue };
          }
          return field;
        })
      );
    } else if (name === formFields[2].name && newValue === "No") {
      setFormData((prevData) => {
        return prevData.map((field) => {
          if (field.name === name) {
            return { ...field, value: newValue };
          }
          if (field.name === "AuditingLocation") {
            return { ...field, value: "NA" };
          }
          return field;
        });
      });
    } else {
      // If not the specified name, proceed with normal form data update
      setFormData((prevData) =>
        prevData.map((field) =>
          field.name === name ? { ...field, value: newValue } : field
        )
      );
    }

    if (name === formFields[2].name && newValue === "Yes"){
      setFormData((prevData) => {
        return prevData.map((field) => {
          // if (field.name === name) {
          //   return { ...field, value: newValue };
          // }
          if (field.name === "AuditingLocation") {
            return { ...field, value: "" };
          }
          return field;
        });
      });
    }
  };

  const handleRadioChange = (name, value) => {
    handleChange(name, value);
  };
  const handleInputChange = (name, value) => {
    handleChange(name, value);
  };

  const offsiteActivityValue =
    formData.find((item) => item.name === formFields[0].name)?.value === "Yes";
  const offsiteActivityValueNo =
    formData.find((item) => item.name === formFields[0].name)?.value === "No";
  const locationAuditedValue =
    formData.find((item) => item.name === formFields[2].name)?.value === "Yes";
  const locationAuditedValueNo =
    formData.find((item) => item.name === formFields[2].name)?.value === "No";
  const typeOffsiteActivityValue = formData.find(
    (item) => item.name === formFields[1].name
  )?.value;
  const siteNameValue = formData.find(
    (item) => item.name === formFields[3].name
  )?.value;
  const AuditingLocationvalue = formData.find(
    (item) => item.name === formFields[4].name
  )?.value;

  useEffect(() => {
    if (offsiteActivityValue && locationAuditedValue) {
      setSubmitDisable(
        !(typeOffsiteActivityValue && siteNameValue && AuditingLocationvalue)
      );
    } else if (offsiteActivityValue && locationAuditedValueNo) {
      setSubmitDisable(!(typeOffsiteActivityValue && siteNameValue));
    } else if (offsiteActivityValueNo) {
      setSubmitDisable(false);
      // alert("no setted");
    }
  }, [
    offsiteActivityValue,
    locationAuditedValue,
    typeOffsiteActivityValue,
    siteNameValue,
    AuditingLocationvalue,
    offsiteActivityValueNo,
  ]);
  useEffect(() => {}, [formData]);



  return (
    <div id="form-component">
      <form>
        <div className="form-component-container">
          {/* // first field here  */}
          <div className="input-box">
            <label className="input-label">
              {formFields[0].label} <span className="required-span">*</span>
            </label>
            <div className="radio-container">
              {formFields[0].options.map((option, idx) => (
                <label
                  className="radio-field"
                  key={idx}
                  style={{ marginRight: "10px" }}
                >
                  <input
                    type="radio"
                    className="radio-circle"
                    name={formFields[0].name}
                    value={option}
                    required={formFields[0].required}
                    checked={
                      formData.find((item) => item.name === formFields[0].name)
                        ?.value === option
                    }
                    onChange={() =>
                      handleRadioChange(formFields[0].name, option)
                    }
                  />
                  <span className="radio-option-text">{option}</span>
                </label>
              ))}
            </div>
          </div>

          {/* // second field here  */}
          <div className="input-box">
            <label className="input-label">
              {formFields[1].label} <span className="required-span">*</span>
            </label>
            <input
              className="input-field"
              type={formFields[1].type}
              id={formFields[1].name}
              name={formFields[1].name}
              placeholder={formFields[1].placeholder || ""}
              required={formFields[1].required}
              value={
                formData.find((item) => item.name === formFields[1].name)
                  ?.value === "NA"
                  ? ""
                  : formData.find((item) => item.name === formFields[1].name)
                      ?.value || ""
              }
              onChange={
                (e) => handleInputChange(formFields[1].name, e.target.value) // Handling input field change
              }
              disabled={
                formData.find((item) => item.name === formFields[0].name)
                  ?.value !== "Yes"
              }
            />
          </div>

          {/* // third field here  */}
          <div className="input-box">
            <label className="input-label">
              {formFields[2].label} <span className="required-span">*</span>
            </label>
            <div className="radio-container">
              {formFields[2].options.map((option, idx) => (
                <label
                  className="radio-field"
                  key={idx}
                  style={{ marginRight: "10px" }}
                >
                  <input
                    type="radio"
                    className="radio-circle"
                    name={formFields[2].name}
                    value={offsiteActivityValue ? offsiteActivityValue : option}
                    required={formFields[2].required}
                    checked={
                      formData.find((item) => item.name === formFields[2].name)
                        ?.value === option
                    }
                    onChange={() =>
                      handleRadioChange(formFields[2].name, option)
                    }
                    disabled={
                      formData.find((item) => item.name === formFields[0].name)
                        ?.value === "No"
                    }
                  />
                  <span className="radio-option-text">{option}</span>
                </label>
              ))}
            </div>
          </div>

          {/* // fourth field here */}
          <div className="input-box">
            <label className="input-label">
              {formFields[3].label} <span className="required-span">*</span>
            </label>
            <input
              className="input-field"
              type={formFields[3].type}
              id={formFields[3].name}
              name={formFields[3].name}
              placeholder={formFields[3].placeholder || ""}
              required={formFields[3].required}
              value={
                formData.find((item) => item.name === formFields[3].name)
                  ?.value === "NA"
                  ? ""
                  : formData.find((item) => item.name === formFields[3].name)
                      ?.value || ""
              }
              onChange={
                (e) => handleInputChange(formFields[3].name, e.target.value) // Handling input field change
              }
              disabled={
                formData.find((item) => item.name === formFields[0].name)
                  ?.value !== "Yes"
              }
            />
          </div>

          {/* // fifth field here  */}
          <div className="input-box">
            <label className="input-label">
              {formFields[4].label} <span className="required-span">*</span>
            </label>
            <input
              className={`input-field ${
                formData.find((item) => item.name === formFields[0].name)
                  ?.value === "No"
                  ? "offsite-input-field-disable"
                  : " "
              }`}
              type={formFields[4].type}
              id={formFields[4].name}
              name={formFields[4].name}
              placeholder={formFields[4].placeholder || ""}
              required={formFields[4].required}
              value={
                formData.find((item) => item.name === formFields[4].name)
                  ?.value === "NA"
                  ? ""
                  : formData.find((item) => item.name === formFields[4].name)
                      ?.value || ""
              }
              onChange={
                (e) => handleInputChange(formFields[4].name, e.target.value) // Handling input field change
              }
              disabled={
                formData.find((item) => item.name === formFields[0].name)
                  ?.value === "No" ||
                !formData.find((item) => item.name === formFields[0].name)
                  ?.value ||
                formData.find((item) => item.name === formFields[2].name)
                  ?.value === "No"
              }
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default OffsiteActivityStaticForm;
